import { render, staticRenderFns } from "./header-text-clamp.vue?vue&type=template&id=58510e96&scoped=true&"
import script from "./header-text-clamp.vue?vue&type=script&lang=js&"
export * from "./header-text-clamp.vue?vue&type=script&lang=js&"
import style0 from "./header-text-clamp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./header-text-clamp.vue?vue&type=style&index=1&id=58510e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58510e96",
  null
  
)

export default component.exports